import React, { useEffect, useMemo, useRef, useState } from "react";
import "../collector/collector.css";
import "../configMikrotik/configmikrotik.css";
import {
  ArrowClockwise,
  WifiOff,
  Wifi,
  ThreeDots,
  ArchiveFill,
  Server,
  Envelope,
  FileExcelFill,
  FilterCircle,
  Router,
  PrinterFill,
  ArrowBarLeft,
  ArrowBarRight,
  HddNetworkFill,
  Bezier2,
  Shuffle,
} from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";

// internal imports
import { toast, ToastContainer } from "react-toastify";
import useDash from "../../assets/css/dash.module.css";
import Sidebar from "../../components/admin/sidebar/Sidebar";
import { FourGround, FontColor } from "../../assets/js/theme";
import Footer from "../../components/admin/footer/Footer";

import Loader from "../../components/common/Loader";
import {
  fetchMikrotik,
  getPPPoEActiveCustomer,
  getArea,
  pppoeMACBinding,
  pppoeRemoveMACBinding,
  getActiveCustomerPing,
  getAllPackages,
  removeCustomerActiveConnection,
} from "../../features/apiCalls";

import Table from "../../components/table/Table";
import { useTranslation } from "react-i18next";
import BandwidthModal from "../Customer/BandwidthModal";
import moment from "moment";
import CustomerDelete from "../Customer/customerCRUD/CustomerDelete";
import IndeterminateCheckbox from "../../components/table/bulkCheckbox";
import BulkCustomerDelete from "../Customer/customerCRUD/bulkOpration/BulkdeleteModal";
import BulkCustomerMessage from "../Customer/customerCRUD/bulkOpration/BulkCustomerMessage";
import { CSVLink } from "react-csv";
import { getSubAreasApi } from "../../features/actions/customerApiCall";
import { Accordion, Card, Collapse } from "react-bootstrap";
import NetFeeBulletin from "../../components/bulletin/NetFeeBulletin";
import { getBulletinPermission } from "../../features/apiCallAdmin";
import ActiveCustomerPDF from "../Customer/ActiveCustomerPrint";
import ReactToPrint from "react-to-print";
import useISPowner from "../../hooks/useISPOwner";
import { btrcHeader, newBTRCReport } from "../common/btrcReport";
import { badge } from "../../components/common/Utils";
import useSelectorState from "../../hooks/useSelectorState";
import ONUDetails from "./ONUDetails";
import PingDetails from "./PingDetails";
import DataFilter from "../common/DataFilter";
import useDataState from "../../hooks/useDataState";
import PPPoELiveBandwidth from "../Customer/PPPoELiveBandwidth";
import { connectSocket } from "../../socket";

export default function ConfigMikrotik() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const componentRef = useRef();

  const filterInputPermission = {
    mikrotik: true,
    package: true,
    area: true,
    subArea: true,
    poleBox: true,
    connectionStatus: true,
    status: true,
  };

  //---> Get user & current user data form useISPOwner hooks
  const { role, ispOwnerData, ispOwnerId, bpSettings, userData, currentUser } =
    useISPowner();

  //---> Get redux store state data from useSelectorState hooks
  const { areas, subAreas, mikrotiks, bulletinPermission, allPackages } =
    useSelectorState();

  //---> Get filtered dataset from useDataState hook
  const { filterOptions, setFilterOption } = useDataState();

  // get all mikrotik from redux
  const mikrotik = useSelector((state) => state?.mikrotik?.mikrotik);

  // get all static customer
  let allMikrotikUsers = useSelector((state) => state?.mikrotik?.pppoeUser);

  // loading state
  const [loading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);

  // bulk customer state
  const [bulkCustomers, setBulkCustomer] = useState([]);

  // customer loading state
  const [mtkLoading, setMtkLoading] = useState(false);

  // filter Accordion handle state
  const [activeKeys, setActiveKeys] = useState("");

  // customer state
  let [allUsers, setAllUsers] = useState(allMikrotikUsers);

  // customer id state
  const [customerDeleteId, setCustomerDeleteId] = useState("");

  // customer id state
  const [bandWidthCustomerData, setBandWidthCustomerData] = useState();

  //bandwidth modal state
  const [bandWidthModal, setBandWidthModal] = useState(false);

  // check uncheck mikrotik state when delete customer
  const [checkMikrotik, setMikrotikCheck] = useState(false);

  // area & subarea name
  const [areaName, setAreaName] = useState("");
  const [subareaName, setSubareaName] = useState("");

  // modal show state
  const [modalStatus, setModalStatus] = useState("");
  const [show, setShow] = useState(false);

  //set customer type bulk oparation
  const [customerType, setCustomerType] = useState();

  const [customer, setCustomer] = useState({});

  // find single mikrotik details
  const singleMik = mikrotiks.find(
    (item) => item.id === filterOptions.mikrotik,
  );

  //================// API CALL's //================//
  useEffect(() => {
    connectSocket(currentUser?.user.id);

    //===========================================================> FIRST API

    //---> @Get ispOwner areas sub-area data
    !subAreas.length && getSubAreasApi(dispatch, ispOwnerId);

    //===========================================================> LAST API

    //---> @Get ispOwner areas data
    !areas?.length && getArea(dispatch, ispOwnerId, setIsLoading);

    //---> @Get ispOwner mikrotiks data
    !mikrotiks?.length && fetchMikrotik(dispatch, ispOwnerId, setIsLoading);

    //---> @Get ispOwner all mikrotik packages data
    !allPackages.length && getAllPackages(dispatch, ispOwnerId, setIsLoading);

    //---> @Get bulletin permissions data
    Object.keys(bulletinPermission)?.length === 0 &&
      getBulletinPermission(dispatch);
  }, []);

  // api call for get update static customer
  useEffect(() => {
    if (filterOptions.mikrotik) {
      getPPPoEActiveCustomer(
        dispatch,
        IDs,
        singleMik?.name,
        setMtkLoading,
        "user",
      );
    }
  }, [filterOptions.mikrotik]);

  // set mikrotik and customer into state
  useEffect(() => {
    setAllUsers(allMikrotikUsers);
  }, [allMikrotikUsers, mikrotik]);

  // customer delete controller
  const customerDelete = (customerId) => {
    setMikrotikCheck(false);
    setCustomerDeleteId(customerId);
  };

  // customer bandwidth handler
  const bandwidthModalController = (customer) => {
    setBandWidthCustomerData(customer);
    setBandWidthModal(true);
    setModalStatus("bandwidth");
  };

  const connectionPingTest = (customer) => {
    setShow(true);
    setCustomer(customer);
    setModalStatus("ping");
  };

  const handleCustomerRemoveFormActiveConnection = (customer) => {
    const confirm = window.confirm(t("areYouSure"));

    if (confirm) {
      removeCustomerActiveConnection(dispatch, customer?.id, setIsLoading);
    }
  };

  // initialize id
  const IDs = {
    ispOwner: ispOwnerId,
    mikrotikId: filterOptions.mikrotik,
  };

  // reload handler
  const reloadHandler = () => {
    getPPPoEActiveCustomer(
      dispatch,
      IDs,
      singleMik?.name,
      setMtkLoading,
      "user",
    );
    fetchMikrotik(dispatch, ispOwnerId, setIsLoading);
  };

  const sortingCustomer = useMemo(() => {
    return [...allUsers].sort((a, b) => {
      a = parseInt(a.customerId?.replace(/[^0-9]/g, ""));
      b = parseInt(b.customerId?.replace(/[^0-9]/g, ""));

      return a - b;
    });
  }, [allUsers]);

  const tableData = useMemo(() => sortingCustomer, [allUsers]);

  //mac-binding handler
  const macBindingCall = (customerId) => {
    pppoeMACBinding(customerId);
  };
  const macBindingRemove = (customerId) => {
    pppoeRemoveMACBinding(customerId);
  };

  // table column
  const columns = React.useMemo(
    () => [
      {
        id: "selection",
        Header: ({ getToggleAllPageRowsSelectedProps }) => (
          <IndeterminateCheckbox
            customeStyle={true}
            {...getToggleAllPageRowsSelectedProps()}
          />
        ),
        Cell: ({ row }) => (
          <div>
            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
          </div>
        ),
        width: "2%",
      },
      {
        width: "3%",
        Header: <Wifi />,
        accessor: "running",
        Cell: ({ value }) => (
          <div>{value ? <Wifi color="green" /> : <WifiOff color="red" />}</div>
        ),
      },
      {
        width: "5%",
        Header: t("id"),
        accessor: "customerId",
      },
      {
        width: "10%",
        Header: t("namePPPoE"),
        accessor: (data) => `${data?.name} ${data.pppoe?.name}`,
        Cell: ({ row: { original } }) => (
          <div>
            <p>{original?.name}</p>
            <p>{original.pppoe?.name}</p>
          </div>
        ),
      },
      {
        width: "10%",
        Header: t("IPMac"),
        accessor: (data) => `${data?.ip} ${data.callerId}`,
        Cell: ({ row: { original } }) => (
          <div style={{ cursor: "pointer" }}>
            <p
              onClick={() => window.open(`http://${original?.ip}`, "_blank")}
              style={{
                cursor: "pointer",
                textDecoration: "none",
                color: "inherit",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = "underline";
                e.currentTarget.classList.add("text-primary");
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = "none";
                e.currentTarget.classList.remove("text-primary");
              }}
            >
              {original?.ip}
            </p>

            <p className={`text-${original?.macBinding && "success fw-bold"}`}>
              {original?.callerId}
            </p>
          </div>
        ),
      },
      {
        width: "8%",
        Header: t("package"),
        accessor: "pppoe.profile",
      },
      {
        width: "8%",
        Header: t("upDown"),
        accessor: (data) => data?.txByte,
        Cell: ({ row: { original } }) => (
          <div
            style={{
              padding: "15px 15px 15px 0 !important",
            }}
          >
            <p>
              {original?.rxByte
                ? original?.rxByte / 1024 / 1024 <= 1024
                  ? (original?.rxByte / 1024 / 1024).toFixed(2) + " MB"
                  : (original?.rxByte / 1024 / 1024 / 1024).toFixed(2) + " GB"
                : ""}
            </p>

            <p>
              {original?.txByte
                ? original?.txByte / 1024 / 1024 <= 1024
                  ? (original?.txByte / 1024 / 1024).toFixed(2) + " MB"
                  : (original?.txByte / 1024 / 1024 / 1024).toFixed(2) + " GB"
                : ""}
            </p>
          </div>
        ),
      },
      {
        width: "8%",
        Header: t("uptime"),
        accessor: "uptime",
        Cell: ({ row: { original } }) => (
          <div>
            {original?.uptime ? (
              original?.uptime
            ) : (
              <p className="text-danger">
                {(() => {
                  const diffInSeconds = moment().diff(
                    moment(original?.lastLogoutTime),
                    "seconds",
                  );

                  const weeks = Math.floor(diffInSeconds / (60 * 60 * 24 * 7));
                  const days = Math.floor(
                    (diffInSeconds % (60 * 60 * 24 * 7)) / (60 * 60 * 24),
                  );
                  const hours = Math.floor(
                    (diffInSeconds % (60 * 60 * 24)) / (60 * 60),
                  );
                  const minutes = Math.floor((diffInSeconds % (60 * 60)) / 60);
                  const seconds = diffInSeconds % 60;

                  return (
                    <>
                      {weeks > 0 && <span>{weeks}w</span>}
                      {days > 0 && <span>{days}d</span>}
                      {hours > 0 && <span>{hours}h</span>}
                      {minutes > 0 && <span>{minutes}m</span>}
                      <span>{seconds}s</span>
                    </>
                  );
                })()}
              </p>
            )}
          </div>
        ),
      },
      {
        width: "15%",
        Header: t("loggedInOut"),
        accessor: (data) => `${data?.lastLinkUpTime} ${data?.lastLogoutTime}`,
        Cell: ({ row: { original } }) => (
          <div>
            <p>
              {original?.lastLinkUpTime &&
                moment(original.lastLinkUpTime).format("YYYY/MM/DD hh:mm A")}
            </p>
            <p>
              {original?.lastLogoutTime &&
                moment(original.lastLogoutTime).format("YYYY/MM/DD hh:mm A")}
            </p>
          </div>
        ),
      },
      {
        width: "5%",
        Header: t("status"),
        accessor: (data) => data.status,
        Cell: ({ row: { original } }) => <div>{badge(original?.status)}</div>,
      },
      {
        width: "5%",
        Header: () => <div className="text-center">{t("action")}</div>,
        id: "option",
        Cell: ({ row: { original } }) => {
          return (
            <div className="text-center">
              <div className="dropdown">
                <ThreeDots
                  className="dropdown-toggle ActionDots"
                  id="areaDropdown"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                />

                <ul className="dropdown-menu" aria-labelledby="areaDropdown">
                  {bpSettings?.inActiveCustomerDelete &&
                    original?.running !== true && (
                      <li
                        data-bs-toggle="modal"
                        data-bs-target="#customerDelete"
                        onClick={() => {
                          customerDelete(original.id);
                        }}
                      >
                        <div className="dropdown-item">
                          <div className="customerAction">
                            <ArchiveFill />
                            <p className="actionP">{t("delete")}</p>
                          </div>
                        </div>
                      </li>
                    )}

                  {bpSettings?.hasMikrotik &&
                    bpSettings?.hasOLT &&
                    !bpSettings?.oltUserMonitor &&
                    original?.running === true && (
                      <li
                        onClick={() => {
                          setCustomer(original);
                          setModalStatus("onuDetails");
                          setShow(true);
                        }}
                      >
                        <div className="dropdown-item">
                          <div className="customerAction">
                            <HddNetworkFill />
                            <p className="actionP">{t("onuLaser")}</p>
                          </div>
                        </div>
                      </li>
                    )}

                  {bpSettings?.hasMikrotik && original?.running === true && (
                    <li onClick={() => connectionPingTest(original)}>
                      <div className="dropdown-item">
                        <div className="customerAction">
                          <Bezier2 />
                          <p className="actionP">{t("ping")}</p>
                        </div>
                      </div>
                    </li>
                  )}

                  {bpSettings?.hasMikrotik && original?.running === true && (
                    <li onClick={() => bandwidthModalController(original)}>
                      <div className="dropdown-item">
                        <div className="customerAction">
                          <Server />
                          <p className="actionP">{t("bandwidth")}</p>
                        </div>
                      </div>
                    </li>
                  )}

                  {(role === "ispOwner" || role === "manager") &&
                    bpSettings?.hasMikrotik &&
                    original?.running && (
                      <li>
                        {!original?.macBinding ? (
                          <div
                            className="dropdown-item"
                            onClick={() => macBindingCall(original.id)}
                          >
                            <div className="customerAction">
                              <Router />
                              <p className="actionP">{t("macBinding")}</p>
                            </div>
                          </div>
                        ) : (
                          <div
                            className="dropdown-item"
                            onClick={() => macBindingRemove(original.id)}
                          >
                            <div className="customerAction">
                              <Router />
                              <p className="actionP">{t("removeMACBinding")}</p>
                            </div>
                          </div>
                        )}
                      </li>
                    )}

                  {bpSettings?.hasMikrotik && original?.running === true && (
                    <li
                      onClick={() =>
                        handleCustomerRemoveFormActiveConnection(original)
                      }
                    >
                      <div className="dropdown-item">
                        <div className="customerAction">
                          <Shuffle />
                          <p className="actionP">{t("removeConnection")}</p>
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          );
        },
      },
    ],
    [t],
  );

  // mikrotik find in select mikrotik id
  const mikrotikName = mikrotiks.find(
    (val) => val.id === filterOptions.mikrotik,
  );

  const filterData = {
    mikrotik: mikrotikName?.name,
    area: areaName,
    subarea: subareaName,
    customer: filterOptions.connectionStatus,
  };

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />
      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <div>{t("activeCustomer")}</div>

                  <div
                    style={{ height: "45px" }}
                    className="d-flex align-items-center"
                  >
                    <div
                      onClick={() => {
                        if (!activeKeys) {
                          setActiveKeys("filter");
                        } else {
                          setActiveKeys("");
                        }
                      }}
                      title={t("filter")}
                    >
                      <FilterCircle className="addcutmButton" />
                    </div>

                    <div className="reloadBtn">
                      {mtkLoading ? (
                        <Loader className="loader"></Loader>
                      ) : (
                        <ArrowClockwise
                          title={t("refresh")}
                          className="arrowClock"
                          onClick={() => reloadHandler()}
                        ></ArrowClockwise>
                      )}
                    </div>

                    <Collapse in={open} dimension="width">
                      <div id="example-collapse-text">
                        <Card className="cardCollapse border-0">
                          <div className="d-flex align-items-center">
                            <CSVLink
                              data={newBTRCReport(tableData, ispOwnerData)}
                              filename={userData.company}
                              headers={btrcHeader}
                              title="Customer BTRC Report New"
                            >
                              <FileExcelFill className="addcutmButton" />
                            </CSVLink>

                            <div className="addAndSettingIcon">
                              <ReactToPrint
                                documentTitle={t("CustomerList")}
                                trigger={() => (
                                  <PrinterFill
                                    title={t("print")}
                                    className="addcutmButton"
                                  />
                                )}
                                content={() => componentRef.current}
                              />
                            </div>
                          </div>
                        </Card>
                      </div>
                    </Collapse>
                    {!open && (
                      <ArrowBarLeft
                        className="ms-1"
                        size={34}
                        style={{ cursor: "pointer" }}
                        onClick={() => setOpen(!open)}
                        aria-controls="example-collapse-text"
                        aria-expanded={open}
                      />
                    )}
                    {open && (
                      <ArrowBarRight
                        className="ms-1"
                        size={34}
                        style={{ cursor: "pointer" }}
                        onClick={() => setOpen(!open)}
                        aria-controls="example-collapse-text"
                        aria-expanded={open}
                      />
                    )}
                  </div>
                </div>
              </FourGround>

              <FourGround>
                <div className="mt-2">
                  <Accordion alwaysOpen activeKey={activeKeys}>
                    <Accordion.Item eventKey="filter">
                      <Accordion.Body>
                        <DataFilter
                          page="activeCustomer"
                          filterData={allMikrotikUsers}
                          setFilterData={setAllUsers}
                          filterOptions={filterOptions}
                          setFilterOption={setFilterOption}
                          inputPermission={filterInputPermission}
                        />
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  <div className="collectorWrapper pb-2">
                    <div className="d-none">
                      <ActiveCustomerPDF
                        filterData={filterData}
                        currentCustomers={allUsers}
                        ref={componentRef}
                        status="pppoe"
                      />
                    </div>
                    <div className="table-section">
                      <Table
                        isLoading={mtkLoading}
                        bulkLength={bulkCustomers?.length}
                        columns={columns}
                        data={allUsers}
                        bulkState={{
                          setBulkCustomer,
                        }}
                      ></Table>
                    </div>
                  </div>
                </div>
              </FourGround>
              <Footer />
            </FontColor>
          </div>
        </div>

        {(bulletinPermission?.activeCustomer ||
          bulletinPermission?.allPage) && <NetFeeBulletin />}
      </div>

      {bulkCustomers.length > 0 && (
        <>
          <div className="bulkActionButton">
            {bpSettings?.inActiveCustomerDelete &&
              customerType === "ofline" &&
              (role === "ispOwner" || role === "manager") && (
                <button
                  className="bulk_action_button"
                  title={t("bulkDeleteCustomer")}
                  type="button"
                  class="btn btn-danger btn-floating btn-sm"
                  onClick={() => {
                    setModalStatus("customerDelete");
                    setShow(true);
                  }}
                >
                  <ArchiveFill />
                  <span className="button_title"> {t("customerDelete")} </span>
                </button>
              )}

            {bpSettings?.unpaidCustomerBulkSms &&
              customerType === "ofline" &&
              (role === "ispOwner" || role === "manager") && (
                <button
                  className="bulk_action_button"
                  title={t("bulkMessage")}
                  onClick={() => {
                    setModalStatus("bulkMessage");
                    setShow(true);
                  }}
                  type="button"
                  class="btn btn-primary btn-floating btn-sm"
                >
                  <Envelope />
                  <span className="button_title"> {t("bulkMessage")} </span>
                </button>
              )}
          </div>
        </>
      )}

      {/*bulk customer delete modal  */}

      {/* inactive & offline customer bulk delete modal */}
      {modalStatus === "customerDelete" && (
        <BulkCustomerDelete
          bulkCustomer={bulkCustomers}
          show={show}
          setShow={setShow}
        />
      )}

      {/* offline customer bulk message modal */}
      {modalStatus === "bulkMessage" && (
        <BulkCustomerMessage
          bulkCustomer={bulkCustomers}
          show={show}
          setShow={setShow}
        />
      )}

      <CustomerDelete
        single={customerDeleteId}
        mikrotikCheck={checkMikrotik}
        setMikrotikCheck={setMikrotikCheck}
        status="customerDelete"
      />

      {modalStatus === "bandwidth" && (
        <PPPoELiveBandwidth
          show={bandWidthModal}
          setShow={setBandWidthModal}
          customer={bandWidthCustomerData}
        />
      )}

      {/* {modalStatus === "bandwidth" && (
        <BandwidthModal
          setModalShow={setBandWidthModal}
          modalShow={bandWidthModal}
          customer={{ ...bandWidthCustomerData, page: "PPPoE" }}
        />
      )} */}

      {/* Customer ONU Information Dialog */}
      {modalStatus === "onuDetails" && (
        <ONUDetails {...{ show, setShow, customer }} />
      )}

      {/* Customer Ping Information Dialog */}
      {modalStatus === "ping" && (
        <PingDetails {...{ show, setShow, customer }} />
      )}
    </>
  );
}
